import React from 'react';
import { withTheme } from 'styled-components';
import { defaultProps, propTypes } from '../props';
import DefaultLogo from './DefaultLogo';
import SmallLogo from './SmallLogo';
/**
 * This component will either render the default (large) logo
 * or the small logo depending on media queries.
 */

const Logo = ({
  color
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DefaultLogo, {
  responsive: true,
  color: color
}), /*#__PURE__*/React.createElement(SmallLogo, {
  responsive: true,
  color: color
}));

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;
export default withTheme(Logo);